import React, { useEffect, useState } from "react";
import QRCodeSection from "../components/UserDashboard/QRCodeSection";
import MenuUploadDownload from "../components/UserDashboard/MenuUploadDownload";
import ProfileDrawer from "../components/UserDashboard/ProfileDrawer"
import UserBG from "../assets/loginBG.jpg";
import { useAuth } from "../state/AuthContext";
import { useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../utils/firebase";
import ChangePasswordModal from "../components/UserDashboard/ChangePassword";
import EditWhatsappModal from "../components/UserDashboard/EditWhatsappModal";
import { FaBars, FaTimes, FaKey, FaSignOutAlt, FaWhatsapp, FaShoppingCart, FaStore, FaChartLine, FaEdit, FaRegEdit, FaListAlt, FaPowerOff, FaBullseye, FaMegaport, FaBullhorn } from 'react-icons/fa'; // Icons for hamburger and buttons
import Footer from "../components/Consumer/Footer";
import { toast, ToastContainer } from "react-toastify";
import { downloadMenu, handleUpload } from "../utils/DownloadMenu";
import { FaUser } from "react-icons/fa";
//@ts-ignore
import CryptoJS from 'crypto-js';

//user Onboarding Journey
import { driver } from "driver.js";
import "../styles/driver.css"
import ZaffloPremiumCard from "../components/UserDashboard/ZaffloPremiumCard";
import ReferralModal from "../components/UserDashboard/ReferralModel"


const UserDashboard = () => {
  const { logout, user } = useAuth();

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userDetails, setUserDetails] = useState();
  const [error, setError] = useState();
  const [menuDetails, setMenuDetails] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [decryptedPassword, setDecryptedPassword] = useState('');
  const [showReferralModal, setShowReferralModal] = useState(false);
  //console.log("my user---======111", user, 'password', decryptedPassword);
  const handleLogout = () => {
    logout(navigate);
  };

  const handleOrders = () => {
    navigate('/orders', { state: { user: user } });
  };

  const handleCounter = () => {
    navigate('/counter', { state: { user: user } });
  };

  const handleAnalytics = () => {
    navigate('/analytics', { state: { user: user } });
  };

  const handleMenuEditor = () => {
    navigate('/menueditor', { state: { user: user } });
  };

  const handleTemplates = () => {
    navigate('/templates', { state: { user: user } });
  };


  //console.log("diffffffff",user?.email=== user, 'sdcsdcsdc', user, 'sdcsdcsdc', user?.email)
  useEffect(() => {
    if (user?.email || user) {
      fetchDashboardDetails();
    }
  }, [user]);

  //console.log("suususuus", userDetails, "menehueuue", menuDetails);

  const generateId = () => {
    // const id = formData?.businessName
    //   .toLowerCase()
    //   .replace(/\s+/g, "-")
    //   .replace(/[^a-z0-9-]/g, "");
    // console.log("id", id);
    // setFormData((prev) => ({ ...prev, businessName: id }));
  };

  const SECRET_KEY = process.env.REACT_APP_ENCRYPTION_KEY;

  const decryptPassword = (encryptedPassword) => {
    const bytes = CryptoJS.AES.decrypt(encryptedPassword, SECRET_KEY);
    setDecryptedPassword(bytes.toString(CryptoJS.enc.Utf8));
  };


  const fetchDashboardDetails = async () => {
    try {
      if (!menuDetails) {
        const userDocRef = doc(db, "userDetails", (user?.email || user));
        const userSnap = await getDoc(userDocRef);

        if (userSnap.exists()) {
          const userData = userSnap.data();
          setUserDetails(userData);
          // decrypt password
          decryptPassword(userData?.password);
          //This is the logic to check if menu is not downloading -- It could be name mismatch
          if (userData?.businessName) {
            const menuRef = doc(
              db,
              "menus",
              userData?.businessName
                //These changes are done on 03/05/2025 by Arvind - To allow download of the english menu
                .toLowerCase()
                .replace(/\s+/g, "-")
                .replace(/[^a-z0-9-]/g, "")

            );

            // console.log(
            //   "menuuuu",
            //    menuRef,
            //   "idididiidd",
            //   userData?.businessName
            //     .toLowerCase()
            //     .replace(/\s+/g, "-")
            //     .replace(/[^a-z0-9-]/g, "")
            // );
            const menuSnap = await getDoc(menuRef);

            if (menuSnap.exists()) {
              setMenuDetails(menuSnap.data());
            } else {
              setError("Menu details not found.");
            }
          }
        } else {
          setError("User not found.");
        }
      } else return
    } catch (err) {
      //console.error("Error fetching data:", err);
      setError("Failed to fetch details.");
    } finally {
      setLoading(false);
    }
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false); // State to manage menu visibility

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onDownloadEnglishMenu = () => {
    let hasDownload = downloadMenu(menuDetails?.englishMenu)
    if (hasDownload === -1) {
      toast.info("English Menu is not available");
    } else if (hasDownload === 1) {
      toast.success("Menu Downloaded Successfully")
      return;
    } else {
      toast.error("Something went wrong, please try again later!")
    }
  }
  const onDownloadHindiMenu = () => {
    let hasDownload = downloadMenu(menuDetails?.hindiMenu)
    if (hasDownload === -1) {
      toast.info("Indian Menu is not available");
    } else if (hasDownload === 1) {
      toast.success("Menu Downloaded Successfully")
    } else {
      toast.error("Something went wrong, please try again later!")
    }
  }
  const onUploadEnglishMenu = (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      console.log("Selected English Menu File:", file);
    }
    handleUpload(file, userDetails?.businessName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, ""), 'englishMenu')

  }
  const onUploadHindiMenu = (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      //console.log("Selected Hindi Menu File:", file);
    }
    handleUpload(file, userDetails?.businessName
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, ""), 'hindiMenu')
  }


  // ===== ONBOARDING TOUR =====
  const [showOnboarding, setShowOnboarding] = useState(false);
  const [showTourPrompt, setShowTourPrompt] = useState(false);
  const [tourStarted, setTourStarted] = useState(false);



  useEffect(() => {
    if (!user?.email) return;

    const checkOnboarding = async () => {
      const ref = doc(db, "userDetails", user.email);
      const snap = await getDoc(ref);

      if (snap.exists() && !snap.data().onboardingCompleted) {
        setShowTourPrompt(true);
      }
    };

    checkOnboarding();
  }, [user?.email]);

  // wait until element is in DOM
  const waitForElement = (id, timeout = 6000) =>
    new Promise((resolve) => {
      const start = Date.now();
      const timer = setInterval(() => {
        const el = document.getElementById(id);
        if (el) {
          clearInterval(timer);
          resolve(el);
        }
        if (Date.now() - start > timeout) clearInterval(timer);
      }, 200);
    });

  const startTour = async () => {
    await waitForElement("MenuEditor");

    const steps = [
      { element: "#UserProfile", popover: { title: "User Proflie", description: "Create, update, and manage your complete profile here." } },
      { element: "#MenuEditor", popover: { title: "Menu Editor", description: "Create, update, and manage your complete digital menu from here." } },
      { element: "#WhatsApp", popover: { title: "WhatsApp Integration", description: "Add or update your official WhatsApp number. All customer orders will be received on this number." } },
      { element: "#ChangePassword", popover: { title: "Account Security", description: "Change your account password anytime to keep your data safe." } },
      { element: "#LKO", popover: { title: "Live Orders", description: "Monitor all incoming customer orders in real time from this section." } },
      { element: "#Templates", popover: { title: "Marketing Templates", description: "View and manage all whatsapp templates which can be sent with Customers." } },
      { element: "#Analytics", popover: { title: "Business Analytics", description: "Track your sales performance, popular dishes, and customer trends." } },
      { element: "#ExcelUpload", popover: { title: "Bulk Menu Upload", description: "Upload or update your entire menu using an Excel file for faster setup." } },
      { element: "#Payment", popover: { title: "Billing & Subscription", description: "Manage your subscription plan and payment details here." } },
    ].filter(step => document.getElementById(step.element.slice(1)));

    if (!steps.length) return;

    const tour = driver({
      showProgress: true,
      allowClose: true,
      scrollIntoViewOptions: { behavior: "smooth", block: "center" },
      steps,
    });

    tour.drive();

  };

  useEffect(() => {
    if (!tourStarted) return;

    const timer = setTimeout(async () => {
      await updateDoc(doc(db, "userDetails", user?.email), {
        onboardingCompleted: true,
      });
    }, 20000); // time for full tour

    return () => clearTimeout(timer);
  }, [tourStarted]);






  return (
    <div className="min-h-screen relative overflow-hidden">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      {/* Background Image */}
      <img
        className="absolute inset-0 z-0 object-cover w-full h-full opacity-10"
        src={UserBG}
        alt="Dashboard Background"
      />

      <ReferralModal
        isOpen={showReferralModal}
        onClose={() => setShowReferralModal(false)}
        userEmail={user?.email}
      />

      {/* Content */}
      <div className="relative z-10">
        <div className="max-w-7xl mx-auto p-6">

          <div className=" p-2">
            <div className="flex items-center justify-between md:justify-start md:gap-6">
              {/* Toggle Button (Mobile only) */}
              <button
                onClick={toggleMenu}
                className="md:hidden text-gray-800 mr-4"
              >
                {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
              </button>

              {/* Logo and Heading */}
              <div id="UserProfile"
                className="relative flex items-center gap-3 cursor-pointer group"
                onClick={() => setOpenProfile(true)}
              >
                <FaUser size={25} className="text-[#6cbb23] hidden md:block" />

                <h1 className="text-2xl md:text-xl text-gray-800">
                  <strong className="text-[#6cbb23]">
                    {userDetails?.businessName}
                  </strong>
                  <span className="tooltip">View profile</span>
                </h1>
              </div>

              <div className="relative group">
                <div className="">
                  <span className="bg-[#6cbb23]/10 text-[#6cbb23] text-xs font-bold px-2 py-1 rounded-md">
                    {userDetails?.accountType === "TRIAL" ? "TRIAL USER" : "PRO USER"}
                  </span>
                </div>
                <span className="tooltip">Account Type</span>
              </div>


              {/* Buttons (Desktop only) */}
              <div className="hidden md:flex items-center gap-2 ml-auto">

                {/* Menu Editor */}
                <div className="relative group">
                  <button
                    id="MenuEditor"
                    onClick={handleMenuEditor}
                    className="icon-btn text-[#6cbb23]"
                  >
                    <FaListAlt />
                  </button>
                  <span className="tooltip">Add / Edit Menu</span>
                </div>

                {/* WhatsApp */}
                <div className="relative group">
                  <button
                    id="WhatsApp"
                    onClick={() => setIsModalOpen1(true)}
                    className="icon-btn text-[#25D366]"
                  >
                    <FaWhatsapp />
                  </button>
                  <span className="tooltip">Update WhatsApp Number</span>
                </div>

                {/* Change Password */}
                <div className="relative group">
                  <button
                    id="ChangePassword"
                    onClick={() => setIsModalOpen(true)}
                    className="icon-btn"
                  >
                    <FaKey />
                  </button>
                  <span className="tooltip">Change Password</span>
                </div>

                {/* Live Orders – Kitchen */}
                <div className="relative group">
                  <button
                    id="LKO"
                    onClick={handleOrders}
                    className="icon-btn"
                  >
                    <FaShoppingCart />
                  </button>
                  <span className="tooltip">Live Orders – Staff</span>
                </div>

                {/* Live Orders – Counter */}
                {/*<div className="relative group">
    <button
      id="LCO"
      onClick={handleCounter}
      className="icon-btn"
    >
      <FaStore />
    </button>
    <span className="tooltip">Live Orders – Counter</span>
  </div>*/}

                {/* Marketing Templates */}
                <div className="relative group">
                  <button
                    id="Templates"
                    onClick={handleTemplates}
                    className="icon-btn"
                  >
                    <FaBullhorn />
                  </button>
                  <span className="tooltip">Marketing Templates</span>
                </div>

                {/* Analytics */}
                <div className="relative group">
                  <button
                    id="Analytics"
                    onClick={handleAnalytics}
                    className="icon-btn"
                  >
                    <FaChartLine />
                  </button>
                  <span className="tooltip">Analytics</span>
                </div>


                {/* Logout (destructive) */}
                <div className="relative group">
                  <button
                    onClick={handleLogout}
                    className="icon-btn text-red-600 border-red-200 bg-red-50 hover:bg-red-100 hover:text-red-700"
                  >
                    <FaPowerOff />
                  </button>
                  <span className="tooltip">Logout</span>
                </div>


              </div>


            </div>

            {/* Buttons (Mobile View when Toggled) */}
            {isMenuOpen && (
              <div className="mt-5 md:hidden">
                <div className="grid grid-cols-2 gap-3">

                  {/* Menu */}
                  <button
                    onClick={handleMenuEditor}
                    className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition flex flex-col items-center justify-center gap-2"
                  >
                    <FaRegEdit className="text-[#6cbb23] text-xl" />
                    <span className="text-sm font-medium text-gray-700">
                      Menu Editor
                    </span>
                  </button>

                  {/* WhatsApp */}
                  <button
                    onClick={() => setIsModalOpen1(true)}
                    className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition flex flex-col items-center justify-center gap-2"
                  >
                    <FaWhatsapp className="text-[#25D366] text-xl" />
                    <span className="text-sm font-medium text-gray-700">
                      WhatsApp
                    </span>
                  </button>

                  {/* Live Orders */}
                  <button
                    onClick={handleOrders}
                    className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition flex flex-col items-center justify-center gap-2"
                  >
                    <FaShoppingCart className="text-gray-700 text-xl" />
                    <span className="text-sm font-medium text-gray-700">
                      Live Orders
                    </span>
                  </button>

                  {/* Analytics */}
                  <button
                    onClick={handleAnalytics}
                    className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition flex flex-col items-center justify-center gap-2"
                  >
                    <FaChartLine className="text-gray-700 text-xl" />
                    <span className="text-sm font-medium text-gray-700">
                      Analytics
                    </span>
                  </button>

                  {/* Marketing */}
                  <button
                    onClick={handleTemplates}
                    className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition flex flex-col items-center justify-center gap-2"
                  >
                    <FaBullhorn className="text-gray-700 text-xl" />
                    <span className="text-sm font-medium text-gray-700">
                      Templates
                    </span>
                  </button>

                  {/* Change Password */}
                  <button
                    onClick={() => setIsModalOpen(true)}
                    className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition flex flex-col items-center justify-center gap-2"
                  >
                    <FaKey className="text-gray-700 text-xl" />
                    <span className="text-sm font-medium text-gray-700">
                      Password
                    </span>
                  </button>

                </div>

                {/* Logout separated */}
                <button
                  onClick={handleLogout}
                  className="w-full mt-5 bg-red-50 text-red-600 border border-red-200 rounded-xl py-3 flex items-center justify-center gap-2 font-medium hover:bg-red-100 transition"
                >
                  <FaSignOutAlt />
                  Logout
                </button>
              </div>
            )}
          </div>

          {/*  */}

          {/* Welcome Section */}
        <section id="Dash" className="relative overflow-hidden rounded-3xl bg-slate-200 p-1 rounded-2xl mb-10">
  <div className="absolute -top-24 -left-24 h-64 w-64 bg-indigo-500/20 blur-[100px]" />

  <div className="relative bg-white/95 rounded-[calc(1.5rem-1px)] p-8 md:p-10 border border-white/20">
    
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
      
      <div>
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-xs font-bold uppercase tracking-wider mb-4">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-500"></span>
          </span>
          Live Dashboard
        </div>

        <h2 className="text-4xl font-extrabold text-slate-900 tracking-tight leading-none">
          Analyze Your <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-blue-500">Business</span>
        </h2>

        <p className="mt-3 text-slate-500 text-lg max-w-xl">
          Real-time insights into your business performance and billing cycles.
        </p>
      </div>

      {/* 🔥 REFER CTA */}
      <button
        onClick={() => setShowReferralModal(true)}
        className="bg-slate-900 hover:bg-black-700 text-white font-semibold px-6 py-3 rounded-xl shadow-md transition-all"
      >
        🎁 Refer & Earn 1 Month Free
      </button>

    </div>
  </div>
</section>

          {/* Stats Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-8">

            {/* Primary Metric: Total Menu Views */}
            <div className="lg:col-span-1 group relative bg-white border border-slate-200 p-6 rounded-2xl transition-all duration-300 hover:border-indigo-300 hover:shadow-[0_0_30px_-10px_rgba(79,70,229,0.15)]">
              <div className="flex flex-col h-full">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-1">Total Views</p>
                <div className="flex items-baseline gap-1">
                  <h3 className="text-4xl font-black text-slate-900 tabular-nums leading-none">
                    {userDetails?.menuShown ?? "-"}
                  </h3>
                </div>
                <div className="mt-auto pt-6">
                  <div className="h-1 w-full bg-slate-100 rounded-full overflow-hidden">
                    <div className="h-full bg-indigo-500 w-2/3 group-hover:w-full transition-all duration-1000"></div>
                  </div>
                  <p className="text-[10px] text-slate-400 mt-2 uppercase font-medium">Lifetime performance</p>
                </div>
              </div>
            </div>

            {/* Payment Date Metric */}
            <div className="group bg-white border border-slate-200 p-6 rounded-2xl transition-all duration-300 hover:border-slate-300 hover:bg-slate-50/50">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">Last Payment</p>
              <p className="text-xl font-bold text-slate-800">
                {userDetails?.lastPaymentDate
                  ? new Intl.DateTimeFormat("en-GB", { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(userDetails.lastPaymentDate))
                  : "-"}
              </p>
              <div className="mt-4 inline-flex items-center text-[10px] font-bold py-1 px-2 rounded bg-emerald-50 text-emerald-700 uppercase">
                Processed
              </div>
            </div>

            {/* Payment Amount Metric */}
            <div className="group bg-white border border-slate-200 p-6 rounded-2xl transition-all duration-300 hover:border-slate-300 hover:bg-slate-50/50">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">Last Amount</p>
              <p className="text-2xl font-black text-slate-900 tabular-nums">
                {userDetails?.lastPaymentAmount
                  ? '₹' + new Intl.NumberFormat("en-US").format(userDetails.lastPaymentAmount)
                  : "-"}
              </p>
              <p className="text-[10px] text-slate-400 mt-2 uppercase font-medium">Billed Successfully</p>
            </div>

            {/* Next Payment Date Metric */}
            <div className="group bg-white border border-slate-200 p-6 rounded-2xl transition-all duration-300 hover:border-slate-300 hover:bg-slate-50/50">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">Next Billing</p>
              <p className="text-xl font-bold text-slate-800">
                {userDetails?.nextPaymentDate
                  ? new Intl.DateTimeFormat("en-GB", { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date(userDetails.nextPaymentDate))
                  : "-"}
              </p>
              <div className="mt-4 inline-flex items-center text-[10px] font-bold py-1 px-2 rounded bg-amber-50 text-amber-700 uppercase">
                Scheduled
              </div>
            </div>

            {/* Next Amount Metric - Dark Accent */}
            <div className="group bg-white border border-slate-200 p-6 rounded-2xl transition-all duration-300 hover:border-slate-300 hover:bg-slate-50/50">
              <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-4">Next Amount</p>
              <p className="text-2xl font-black text-black tabular-nums">
                {userDetails?.nextPaymentAmount
                  ? '₹' + new Intl.NumberFormat("en-US").format(userDetails.nextPaymentAmount)
                  : "-"}
              </p>
              <p className="text-[10px] text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-blue-500 mt-2 uppercase font-medium">Upcoming Charge</p>
            </div>

          </div>

          {/* QR Code and Menu Upload/Download Section */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
  {/* Menu Section - Takes 2/3 of the space */}
  <div id="ExcelUpload" className="lg:col-span-2 flex flex-col">
    <MenuUploadDownload
      onDownloadEnglishMenu={onDownloadEnglishMenu}
      onDownloadHindiMenu={onDownloadHindiMenu}
      onUploadEnglishMenu={onUploadEnglishMenu}
      onUploadHindiMenu={onUploadHindiMenu}
    />
  </div>

  {/* Premium Card Section - Takes 1/3 of the space */}
  <div id="Payment" className="flex flex-col">
    <ZaffloPremiumCard userDetails={userDetails} />
  </div>
</div>
        </div>
      </div>
      <ChangePasswordModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} password={decryptedPassword} email={userDetails?.email} />
      <EditWhatsappModal isOpen={isModalOpen1} onClose={() => setIsModalOpen1(false)} email={userDetails?.email} />

      {openProfile && (
        <ProfileDrawer
          open={openProfile}
          onClose={() => setOpenProfile(false)}
          userProfile={userDetails}
          userEmail={user?.email || user}
          onProfileUpdated={setUserDetails}
        />
      )}


      <Footer />

      {showTourPrompt && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-full max-w-sm text-center space-y-4 shadow-xl">
            <h2 className="text-lg font-semibold text-gray-800">
              Welcome to Zafflo 👋
            </h2>

            <p className="text-sm text-gray-500">
              Would you like a quick guided tour to understand all features?
            </p>

            <div className="flex justify-center gap-3 pt-2">
              <button
                onClick={async () => {
                  setShowTourPrompt(false);
                  await updateDoc(doc(db, "userDetails", user?.email), {
                    onboardingCompleted: true,
                  });
                }}

                className="px-4 py-2 bg-gray-200 rounded-lg"
              >
                Skip
              </button>

              <button
                onClick={() => {
                  setShowTourPrompt(false);
                  setTourStarted(true);
                  startTour();
                }}

                className="px-4 py-2 bg-[#6cbb23] text-white rounded-lg shadow"
              >
                Start Tour
              </button>
            </div>
          </div>
        </div>
      )}


    </div>
  );
};

export default UserDashboard;
